// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"141":"979651e2","449":"24d1ef12","451":"3e178414","469":"ea6dd19c","495":"df43539f","628":"e8a7c14d","657":"152b5bdf","731":"f35e0d2d"}[chunkId] + ".js";
};